import {lazy} from "react";

export const ReportFuelConsumptionByRouteLazy = lazy(()=>import('./ReportFuelConsumptionByRoute'))